<template>
  <div id="ProgramInfo">

     <!-- Tuition Section -->
    <v-card flat id="buttonShadow"  class=" pb-2">
      <v-layout column align-center justify-center class="grey lighten-4 pb-1" >
        <span class="title font-weight-regular align-center">Tuition   </span>
        <span class="caption grey--text ">Total Program Cost</span>
      </v-layout>

      <v-layout v-if="school.tuition_in_state_resident !== '' && school.tuition_out_of_state_nonresident !== ''" mt-3  pb-2 row justify-space-around>

        <v-card flat>
          <v-layout column align-center>
            <p class="mb-0 title font-weight-regular blue--text text--darken-3"> <span class="font-weight-regular blue--text text--darken-3"></span>${{school.tuition_in_state_resident}} </p>
            <span class="caption ">In State</span>
          </v-layout>
        </v-card>

        <v-card flat>
          <v-layout column align-center>
          <p class="mb-0 title font-weight-regular blue--text text--darken-3"> <span class="font-weight-regular blue--text text--darken-3"></span>${{school.tuition_out_of_state_nonresident}} </p>
            <span class="caption ">Out of State</span>
          </v-layout>
        </v-card>



      </v-layout>
      <v-layout v-if="school.tuition_in_state_resident === '' && school.tuition_out_of_state_nonresident === ''" justify-center mt-3 pb-3>
        <span class="grey--text">Not Listed</span>
      </v-layout>

      <!-- Tuition Notes -->
      <v-card v-if="school.tuitionNotes" outlined class="mx-5 mt-4 mb-4">
        <v-layout align-center justify-center class=" pb-1" >
          <v-icon small class="mr-2">mdi-message-text-outline</v-icon>
          <span class="font-weight-light align-center">Notes </span>
        </v-layout>
        <v-divider></v-divider>
        <v-card-text class="text-center">
          <span>{{school.tuitionNotes}}}</span>
        </v-card-text>
      </v-card>
    </v-card>

    <!-- PANCE pass Rate -->
    <v-card  flat id="buttonShadow" class="mt-6 pb-2">
      <v-layout row align-center justify-center class="grey lighten-4 pb-2 mx-0">
        <span class="title font-weight-regular  align-center mt-1">PANCE Pass Rate   <v-icon @click="showPanceInfoDialog = true" small class="ml-1 mb-1">mdi-information</v-icon> </span>

      </v-layout>

       <v-layout v-if="school.pance_first_time_pass_rate !== '' || school.pance_five_year_first_time_pass_rate !== '' " row mt-3 justify-space-around>


            <v-card flat v-if="school.pance_first_time_pass_rate !== ''">
              <v-layout column align-center>

                  <v-progress-circular width="2" size="80" :value="parseInt(school.pance_first_time_pass_rate)" color="blue darken-3"> <span class="percentageValue title blue--text text--darken-3">{{school.pance_first_time_pass_rate}}<span class="caption ">%</span></span> </v-progress-circular>

                <p class="mt-2 caption ">1st time pass rate</p>
              </v-layout>

            </v-card>


            <v-card flat v-if="school.pance_five_year_first_time_pass_rate !== ''">
              <v-layout column align-center>

                  <v-progress-circular width="2" size="80" :value="parseInt(school.pance_five_year_first_time_pass_rate)" color="blue darken-3"> <span class="percentageValue title blue--text text--darken-3">{{school.pance_five_year_first_time_pass_rate}}<span class="caption">%</span></span> </v-progress-circular>

                <p class="mt-2 caption ">5 year 1st time pass rate</p>
              </v-layout>
            </v-card>

          </v-layout>

          <v-layout v-else justify-center mt-3 pb-3>
            <span class="grey--text">Not Listed</span>
          </v-layout>
          <!-- PANCE PASS Rate Notes -->
          <v-card v-if="school.pancePassRateNotes" outlined class="mx-5 mt-4 mb-4">
            <v-layout align-center justify-center class=" pb-1" >
              <v-icon small class="mr-2">mdi-message-text-outline</v-icon>
              <span class="font-weight-light align-center">Notes </span>
            </v-layout>
            <v-divider></v-divider>
            <v-card-text class="text-center">
              <span>{{school.pancePassRateNotes}}</span>
            </v-card-text>
          </v-card>
          <!-- PANCE INFO DIALOG -->
          <v-dialog
            v-model="showPanceInfoDialog"
            scrollable
            max-width="400"

            style="zIndex:2000"
            >

            <v-card style="borderRadius:10px">
              <v-card-title class="title grey lighten-2 text-xs-center">
                What is the PANCE pass rate?
              </v-card-title>
              <v-card-text class="text-xs-justify mt-2" >
                  Graduating students from an accredited PA program must pass the Physician Assistant National Certifying Exam (PANCE) in order to practice. PA programs report 1st time pass rate (percent of first time test takers in the class who passed the PANCE) and 5-year 1st time pass rate (5-year average percentage of first time test takers in the class who passed the PANCE). These metrics suggest how well the PA Program prepares their students for the PANCE. As a Pre-PA applicant, it is important to choose a school with high pass rates generally above 90%.
              </v-card-text>
              <v-card-actions>
                  <v-btn @click="showPanceInfoDialog = false"  block color="red" dark  class="elevation-0">Close</v-btn>
                </v-card-actions>
            </v-card>

          </v-dialog>

    </v-card>



    <!-- Program Information -->
    <v-card flat id="buttonShadow" class="mt-6 pb-2">
       <v-layout row align-center justify-center class="grey lighten-4 pb-2 mx-0">
        <span class="title font-weight-regular  align-center mt-1">Program Details  </span>

      </v-layout>
      <v-container px-5 >
        <v-layout column>



          <!-- Degee Offered -->
          <v-layout  mt-1 row   align-baseline justify-space-between mx-0>
            <span class="font-weight-light">Degree Offered</span>
            <p v-if="school.degree_offered[0] !== 0" class="subheading  mb-0 blue--text text--darken-3">{{school.degree_offered[0] | removeCharacters}}</p>
            <p v-else></p>

          </v-layout>

          <v-divider class="mt-1 mb-1 " ></v-divider>

          <!-- Program Start Month -->
          <v-layout  mt-1 row   align-baseline justify-space-between mx-0>
            <span class="font-weight-light">Class Start Month</span>
            <p v-if="school.program_start_date !== '' && school.program_start_date !== undefined " class="subheading  blue--text text--darken-3 mb-0">{{ school.program_start_date | removeTimeFromDate | moment('MMMM') }}</p>
            <p v-else class="body-1 mb-0 grey--text">Not Listed</p>
          </v-layout>

          <v-divider class="mt-1 mb-1"></v-divider>

          <!-- Program Duration (Full Time) -->
          <v-layout  mt-1 row   align-baseline justify-space-between mx-0>
            <span class="font-weight-light">Full Time Program Duration</span>
            <p v-if="school.program_duration !== ''" class="subheading blue--text text--darken-3 mb-0">{{school.program_duration}} months</p>
            <p v-else class="body-1 mb-0 grey--text">Not Listed</p>
          </v-layout>

          <v-divider class="mt-1 mb-1"></v-divider>

          <!-- Program Duration (Part Time )-->
          <v-layout  v-if="school.program_duration_part_time !== '' && school.program_duration_part_time !== undefined" mt-1 row   align-baseline justify-space-between mx-0>
            <span class="font-weight-light">Part Time Program Duration </span>
            <p class="subheading blue--text text--darken-3 mb-0">{{school.program_duration_part_time}} months</p>

          </v-layout>

          <v-divider  v-if="school.program_duration_part_time !== '' && school.program_duration_part_time !== undefined" class="mt-1 mb-1"></v-divider>

          <!-- Class Size -->
          <v-layout  mt-1 row   align-baseline justify-space-between mx-0>
            <span class="font-weight-light">Class Size</span>
            <p v-if="school.class_capacity !== '' " class="subheading blue--text text--darken-3 mb-0">{{school.class_capacity}} students</p>
            <p v-else class="body-1 mb-0 grey--text">Not Listed</p>
          </v-layout>

          <v-divider class="mt-1 mb-1"></v-divider>

          <!-- Seat Deposit -->
          <v-layout  mt-1 row   align-baseline justify-space-between mx-0>
            <span class="font-weight-light">Seat Deposit</span>
            <p v-if="school.seat_deposit !== '' " class="subheading blue--text text--darken-3 mb-0"> ${{school.seat_deposit}}</p>
            <p v-else class="body-1 mb-0 grey--text">Not Listed</p>
          </v-layout>
          <v-divider class="mt-1 mb-1"></v-divider>

          <!-- Seat Deposit (Out of State) -->
          <v-layout v-if="school.seat_deposit_out_of_state"  mt-1 row   align-baseline justify-space-between mx-0>
            <span class="font-weight-light">Seat Deposit <span class="caption grey--text">Out of State</span></span>
            <p v-if="school.seat_deposit_out_of_state !== '' " class="subheading blue--text text--darken-3 mb-0"> ${{school.seat_deposit_out_of_state}}</p>

          </v-layout>
          <v-divider v-if="school.seat_deposit_out_of_state" class="mt-1 mb-1"></v-divider>

          <!-- Campus Location -->
          <v-layout  mt-1 row   align-baseline justify-space-between mx-0>
            <span class="font-weight-light">Campus Location</span>
            <p v-if="school.campus_location !== ''" class="subheading blue--text text--darken-3 mb-0">{{school.campus_location}}</p>
            <p v-else class="body-1 mb-0 grey--text">Not Listed</p>
          </v-layout>
          <v-divider v-if="school.campus_location" class="mt-1 mb-1"></v-divider>

           <!-- Rolling Admissions -->
          <v-layout v-if="school.rolling_admissions === true" mt-2 row   align-center justify-space-between mx-0>
            <span class="font-weight-light">Rolling Admissions</span>
            <v-icon color="green" class="mb-0" size="20px">mdi-checkbox-marked-circle</v-icon>
          </v-layout>

          <v-divider v-if="school.rolling_admissions === true" class="mt-1 mb-1"></v-divider>

          <!-- Dual Degree Program -->
          <v-layout v-if="school.dual_degree_program === true" mt-2 row   align-center justify-space-between mx-0>
            <span class="font-weight-light">Dual Degree Program</span>
            <v-icon color="green" class="mb-0" size="20px">mdi-checkbox-marked-circle</v-icon>
          </v-layout>

          <v-divider v-if="school.dual_degree_program === true" class="mt-1 mb-1"></v-divider>

          <!-- Part Time Option Available -->
          <v-layout  v-if="school.part_time_option === true" mt-2 row   align-center justify-space-between mx-0>
            <span class="font-weight-light">Part Time Option Available</span>
            <v-icon color="green" class="mb-0" size="20px">mdi-checkbox-marked-circle</v-icon>
          </v-layout>

          <v-divider v-if="school.part_time_option === true" class="mt-1 mb-1"></v-divider>

          <!-- On Campus Housing Available-->
          <v-layout  v-if="school.on_campus_housing === true" mt-2 row   align-center justify-space-between mx-0>
            <span class="font-weight-light">On Campus Housing Available</span>
            <v-icon color="green" class="mb-0" size="20px">mdi-checkbox-marked-circle</v-icon>
          </v-layout>

          <v-divider v-if="school.on_campus_housing === true" class="mt-1 mb-1"></v-divider>

          <!-- International Students -->
          <v-layout v-if="school.accepts_international_students === true" mt-2 row   align-center justify-space-between mx-0>
            <span class="font-weight-light">International Students Accepted</span>
            <v-icon color="green" class="mb-0" size="20px">mdi-checkbox-marked-circle</v-icon>
          </v-layout>

           <v-divider v-if="school.accepts_international_students === true" class="mt-1 mb-1"></v-divider>

          <!-- Transfer Students Accepted-->
          <v-layout v-if="school.accepts_transfer_students === true" mt-2 row   align-center justify-space-between mx-0>
            <span class="font-weight-light">Transfer Students Accepted</span>
            <v-icon color="green" class="mb-0" size="20px">mdi-checkbox-marked-circle</v-icon>
          </v-layout>

          <v-divider v-if="school.accepts_transfer_students === true" class="mt-1 mb-1"></v-divider>

          <!-- Online Masters Degree -->
          <v-layout  v-if="school.online_masters_degree  === true" mt-2 row   align-center justify-space-between mx-0>
            <span class="font-weight-light">Online Masters Degree</span>
            <v-icon color="green" class="mb-0" size="20px">mdi-checkbox-marked-circle</v-icon>
          </v-layout>

          <v-divider v-if="school.online_masters_degree  === true" class="mt-1 mb-1"></v-divider>

          <!-- Distance Online Learning -->
          <v-layout  v-if="school.distance_online_learning === true"  mt-2 row   align-center justify-space-between mx-0>
            <span class="font-weight-light">Distance Online Learning</span>
            <v-icon color="green" class="mb-0" size="20px">mdi-checkbox-marked-circle</v-icon>
          </v-layout>

          <v-divider v-if="school.distance_online_learning === true" class="mt-1 mb-1"></v-divider>

          <!-- Pre-PA Curriculum -->
          <v-layout  v-if="school.preprofessional_degree_required === true" mt-2 row   align-center justify-space-between mx-0>
            <span class="font-weight-light">Pre-PA Curriculum</span>
            <v-icon color="green" class="mb-0" size="20px">mdi-checkbox-marked-circle</v-icon>
          </v-layout>

          <v-divider v-if="school.preprofessional_degree_required === true" class="mt-1 mb-1"></v-divider>

          <!-- Direct High School Entry -->
          <v-layout  v-if="school.high_school_entry === true" mt-2 row   align-center justify-space-between mx-0>
            <span class="font-weight-light">Direct High School Entry</span>
            <v-icon color="green" class="mb-0" size="20px">mdi-checkbox-marked-circle</v-icon>
          </v-layout>
          <v-divider v-if="school.high_school_entry === true" class="mt-1 mb-1"></v-divider>

          <!-- Cadaver Lab -->
          <v-layout  v-if="school.cadaver_lab === true" mt-2 row   align-center justify-space-between mx-0>
            <span class="font-weight-light">Cadaver Lab</span>
            <v-icon color="green" class="mb-0" size="20px">mdi-checkbox-marked-circle</v-icon>
          </v-layout>
          <v-divider v-if="school.cadaver_lab === true" class="mt-1 mb-1"></v-divider>

          <!-- Faith Based Learning -->
          <v-layout  v-if="school.faith_based === true" mt-2 row   align-center justify-space-between mx-0>
            <span class="font-weight-light">Faith Based Learning</span>
            <v-icon color="green" class="mb-0" size="20px">mdi-checkbox-marked-circle</v-icon>
          </v-layout>
          <v-divider v-if="school.faith_based === true" class="mt-1 mb-1"></v-divider>


        </v-layout>


      </v-container>
        <!-- Details Notes -->
        <v-card  v-if="school.detailsNotes" outlined class="mx-5 mt-4 mb-4">
          <v-layout align-center justify-center class=" pb-1" >
            <v-icon small class="mr-2">mdi-message-text-outline</v-icon>
            <span class="font-weight-light align-center">Notes </span>
          </v-layout>
          <v-divider></v-divider>
          <v-card-text class="text-center">
            <span>{{school.detailsNotes}}</span>
          </v-card-text>
        </v-card>
    </v-card>



  </div>
</template>


<script>
import moment from 'moment'
export default {
  props: ["school"],
  data() {
    return {
      showPanceInfoDialog: false,
    }
  },
  methods: {
    moment
  },
  filters: {
    removeCharacters(string)
        {
            return string.replace(/[^a-zA-Z ]/g, "");
        }
  }
};
</script>

<style scoped>


  .card {
    border-radius: 10px;
  }

      #buttonShadow {
  box-shadow: 0 10px 30px -10px rgba(0,0,0,.19);
}
.progress-circular {
  text-align: center;
}

#nonScience {
  font-size: 10px;
}

.value {
  margin-left: 150px;
}

.percentageValue {
  color: rgb(85, 85, 85);
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/Schools/SchoolDetail/ProgramInfo.vue